import React, { useState } from "react";
import { TextField, Button, Box, Grid, Paper, Stack } from "@mui/material";
import { makeStyles } from "@mui/styles";
import apiAxiosInstance from "../../utils/axiosInstance";

const useStyles = makeStyles(() => ({
  paper: {
    padding: 16,
  },
}));

const Students = () => {
  const classes = useStyles();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    studentId: "",
    readingLevel: "",
    intervention: "",
    interventionResults: "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await apiAxiosInstance.post("/api/students", formData);
      console.log("Student Info saved:", response.data);
      alert("Student added successfully");
    } catch (error) {
      console.error("There was an error adding the student!", error);
    }
  };

  return (
    <Paper className={classes.paper} elevation={1}>
      <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="First Name"
              name="firstName"
              variant="outlined"
              value={formData.firstName}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Last Name"
              name="lastName"
              variant="outlined"
              value={formData.lastName}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Student ID"
              name="studentId"
              variant="outlined"
              value={formData.studentId}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Reading Level"
              name="readingLevel"
              variant="outlined"
              value={formData.readingLevel}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Intervention"
              name="intervention"
              variant="outlined"
              value={formData.intervention}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Intervention Results"
              name="interventionResults"
              variant="outlined"
              value={formData.interventionResults}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <Stack direction="row" justifyContent="flex-end">
              <Button type="submit" variant="contained">
                Add Student
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

export default Students;
